export default __webpack_public_path__ + "static/media/Group-5.8125b1e2.png";